import { PRIMARY_PAYMENT_LIGHT, WHITE } from 'src/global/theme/colors';
import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    title: {
      fontWeight: 700,
    },
    alert: {
      textAlign: 'left',
      width: '100%',
      borderRadius: '10px'
    },
    successAlert: {
      backgroundColor: PRIMARY_PAYMENT_LIGHT,
      color: WHITE,
      "& .MuiAlert-icon": {
        color: WHITE
      }
    }
  };
});
